import { Box, Typography, Button } from "@mui/material";
import { MicCheckSuccessIcon } from "../Icons/MicCheckSuccessIcon";
import { customBlue } from "../../theme/palette";

interface SuccessMicCheckStateProps {
  onStartBenchmark?: () => void;
  taskType?: "activity" | "benchmark";
}

export function SuccessMicCheckState({
  onStartBenchmark,
  taskType = "activity",
}: SuccessMicCheckStateProps) {
  return (
    <>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          mb: 3,
        }}
        aria-label="Microphone Check Success"
      >
        <MicCheckSuccessIcon svg={{ width: 70, height: 70 }} />
      </Box>

      <Box
        sx={{
          textAlign: "center",
          py: 2,
          height: "120px",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Typography
          variant="h6"
          sx={{
            fontSize: "18px",
            color: "#374151",
            fontFamily: "Nunito",
            fontWeight: 800,
            lineHeight: 1.4,
            textAlign: "center",
            mb: 3,
          }}
        >
          You sound great!
          <br />
          Let&apos;s start the{" "}
          {taskType === "benchmark" ? "Benchmark" : "Activity"}!
        </Typography>

        <Button
          variant="contained"
          onClick={onStartBenchmark}
          sx={{
            backgroundColor: customBlue.primaryBlue,
            color: "white",
            textTransform: "uppercase",
            fontWeight: 700,
            fontSize: "14px",
            px: 4,
            py: 1.5,
            height: "48px",
            borderRadius: "8px",
            "&:hover": {
              backgroundColor: customBlue.primaryDark,
            },
          }}
        >
          Done
        </Button>
      </Box>
    </>
  );
}
